/* Quick-add for the cart drawer upsells.
   Habitat re-renders the drawer itself on the 'cart:refresh' document event
   (CartDrawer.refresh -> ?sections=cart-drawer,cart-bubble), so all this needs
   to do is POST the variant and fire that event. The listener is delegated on
   document, so it survives every drawer re-render. */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cd-quick-add__button');
    if (!button) return;
    event.preventDefault();

    var wrap = button.closest('.cd-quick-add');
    var select = wrap ? wrap.querySelector('.cd-quick-add__variant') : null;
    var id = select ? select.value : button.getAttribute('data-variant-id');
    if (!id) return;

    var addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
    button.classList.add('is-loading');
    button.disabled = true;

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Add to cart failed');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (err) {
        button.disabled = false;
        button.classList.remove('is-loading');
        console.error('[cd-quick-add]', err);
      });
  });
})();

/* Carousel arrows for the drawer upsells. Delegated like the quick-add handler
   so they keep working after every drawer re-render. */
(function () {
  function listFor(el) {
    var root = el.closest('.product-recommendations-drawer');
    return root ? root.querySelector('.product-recommendations-drawer__products') : null;
  }

  function syncArrows(list) {
    var root = list.closest('.product-recommendations-drawer');
    if (!root) return;
    var max = list.scrollWidth - list.clientWidth - 1;
    root.querySelectorAll('.cd-recs-arrow').forEach(function (btn) {
      var forward = btn.getAttribute('data-dir') === '1';
      btn.disabled = forward ? list.scrollLeft >= max : list.scrollLeft <= 1;
    });
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.cd-recs-arrow');
    if (!arrow) return;
    event.preventDefault();
    var list = listFor(arrow);
    if (!list) return;
    var dir = Number(arrow.getAttribute('data-dir'));
    var cards = Array.prototype.slice.call(list.querySelectorAll('.product-cart-item'));
    var base = list.getBoundingClientRect().left;
    var target = null;

    if (dir > 0) {
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getBoundingClientRect().left > base + 2) { target = cards[i]; break; }
      }
    } else {
      for (var j = cards.length - 1; j >= 0; j--) {
        if (cards[j].getBoundingClientRect().left < base - 2) { target = cards[j]; break; }
      }
    }

    if (target) {
      list.scrollBy({ left: target.getBoundingClientRect().left - base, behavior: 'smooth' });
    }
    setTimeout(function () { syncArrows(list); }, 450);
  });

  // scroll does not bubble, so listen in the capture phase
  document.addEventListener('scroll', function (event) {
    var el = event.target;
    if (el && el.classList && el.classList.contains('product-recommendations-drawer__products')) {
      syncArrows(el);
    }
  }, true);

  document.addEventListener('cart-drawer:open', function () {
    setTimeout(function () {
      document.querySelectorAll('.product-recommendations-drawer__products').forEach(syncArrows);
    }, 600);
  });
})();
